// extracted by mini-css-extract-plugin
export var textContainer = "textscroll-module--textContainer--W8p6c";
export var text1 = "textscroll-module--text1--QsuUp";
export var text2 = "textscroll-module--text2--1LvU+";
export var scrollingLeft1 = "textscroll-module--scrolling-left1--JTqvF";
export var scrollingLeft2 = "textscroll-module--scrolling-left2--NUM0r";